import {useSearchParams} from "react-router-dom";
import {useState} from "react";
import useCustomPaging from "@/hooks/useCustomPaging";
import { convertLocalToWita } from '@/utils';

const useDatePickerFilter = (key) => {
  const [searchParams] = useSearchParams()
  const [, setFilters] = useCustomPaging()
  const currentTimestampFilter = searchParams.get(key) ?? ''
  const currentTimestamp = currentTimestampFilter
    ? convertLocalToWita(parseInt(currentTimestampFilter, 10))
    : null
  const initialDate = currentTimestamp ? new Date(currentTimestamp) : null
  const [currentDateState, setCurrentDateState] = useState(initialDate)
  const handleChangeDate = (newDate: Date) => {
    setCurrentDateState(newDate)
    setFilters(key, `${newDate?.getTime() ?? ''}`)
  }

  return [
    currentTimestamp,
    currentDateState,
    handleChangeDate
  ] as const
}

export default useDatePickerFilter
